/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseImageGenerationCallGeneratingEvent = {
  type: "response.image_generation_call.generating";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseImageGenerationCallGeneratingEvent$inboundSchema:
  z.ZodType<ResponseImageGenerationCallGeneratingEvent, z.ZodTypeDef, unknown> =
    z.object({
      type: z.literal("response.image_generation_call.generating"),
      sequence_number: z.number().int(),
      item_id: z.string(),
      output_index: z.number().int(),
    }).transform((v) => {
      return remap$(v, {
        "sequence_number": "sequenceNumber",
        "item_id": "itemId",
        "output_index": "outputIndex",
      });
    });
/** @internal */
export type ResponseImageGenerationCallGeneratingEvent$Outbound = {
  type: "response.image_generation_call.generating";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseImageGenerationCallGeneratingEvent$outboundSchema:
  z.ZodType<
    ResponseImageGenerationCallGeneratingEvent$Outbound,
    z.ZodTypeDef,
    ResponseImageGenerationCallGeneratingEvent
  > = z.object({
    type: z.literal("response.image_generation_call.generating"),
    sequenceNumber: z.number().int(),
    itemId: z.string(),
    outputIndex: z.number().int(),
  }).transform((v) => {
    return remap$(v, {
      sequenceNumber: "sequence_number",
      itemId: "item_id",
      outputIndex: "output_index",
    });
  });

export function responseImageGenerationCallGeneratingEventToJSON(
  responseImageGenerationCallGeneratingEvent:
    ResponseImageGenerationCallGeneratingEvent,
): string {
  return JSON.stringify(
    ResponseImageGenerationCallGeneratingEvent$outboundSchema.parse(
      responseImageGenerationCallGeneratingEvent,
    ),
  );
}
export function responseImageGenerationCallGeneratingEventFromJSON(
  jsonString: string,
): SafeParseResult<
  ResponseImageGenerationCallGeneratingEvent,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseImageGenerationCallGeneratingEvent$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ResponseImageGenerationCallGeneratingEvent' from JSON`,
  );
}
